export enum statusTag {
  unverified = 'Unverified',
  active = 'Verified',
  awaiting = 'Awaiting Verification',
  blocked = 'Blocked',
  disabled = 'Disabled',
}
